import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Navbar } from "./Navbar";
import { Footer } from "./Footer";
import { AgeGate } from "./AgeGate";
import { SkipToContent } from "./SkipToContent";

export const Layout = ({ children }) => {
    const { pathname, hash } = useLocation();

    // Scroll to top on route change unless there's a hash
    useEffect(() => {
        if (!hash) window.scrollTo({ top: 0, behavior: "instant" });
    }, [pathname, hash]);

    return (
        <>
            <AgeGate />
            <SkipToContent />
            <Navbar />
            <main id="main-content" data-testid="main-content">
                {children}
            </main>
            <Footer />
        </>
    );
};

export default Layout;
